import React, { useRef, useState, useEffect } from "react";
import "./UploadQuestions.css";
import DropDown from "../CreateBatch/DropdownCB";
import DropDownUP from "./Dropdown";
import DropDownUP2 from "./DropdownUP2";
import { API_BASE_URL } from "../../Config/Config";
import Swal from "sweetalert2";
import FormInput from "../AssignTest/FormInputs";

const UploadQuestions = (dataClient) => {
  const fileInput = useRef(); // reference to your file input
  const [file, setFile] = useState(); // state to store the file
  const [answerKey, setAnswerKey] = useState([]); // state to store the answer key
  const [topicId, setTopicId] = useState(null); // state to store the selected topic id
  const [subtopics, setSubtopics] = useState([]); // state to store the fetched subtopics
  const [dppName, setdppName] = useState([]);
  const [courses, setCourses] = useState([]);
  const [hasData, setHasData] = useState(false);
  const [selectedClass, setSelectedClass] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]); // state to store the fetched chapters
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [topics, setTopics] = useState([]); // state to store the fetched topics
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [testName, setTestName] = useState("");
  const [totalQuestions, setTotalQuestions] = useState(); // state to store the total number of questions
  const [isError, setIsError] = useState(false); // state to indicate if there's an error
  const [displayAnswerKey, setDisplayAnswerKey] = useState([]);
  const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient.dataClient?.client_schema_name[6][0].client_id;
  const [postAnswerKey, setPostAnswerKey] = useState([]);
  const [selectedSubjectLabel, setSelectedSubjectLabel] = useState(""); // Add this line
  const [selectedChapterLabel, setSelectedChapterLabel] = useState("");
  const [selectedTopicLabel, setSelectedTopicLabel] = useState("");
  const [selectedSubtopicId, setSelectedSubtopicId] = useState(null);
  const [selectedSubtopicLabel, setSelectedSubtopicLabel] = useState("");
  const [testId, setTestId] = useState("");
  const [batchId, setBatchId] = useState("");
  const [due_dateId, setDue_dateId] = useState("");
  const [testNameByID, setTestNameByID] = useState("");
  const [batchnameByCourseID, setBatchNameByCourseID] = useState("");
  const [dropdownKey, setDropdownKey] = useState(0);

  const convertOptions = (option) => {
    switch (option) {
      case "A":
        return 1;
      case "B":
        return 2;
      case "C":
        return 3;
      case "D":
        return 4;
      case "E":
        return 5;
      default:
        return option;
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // const handleUpload = async () => {
  //   // Check if file is selected
  //   if (!file) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "No file selected!",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return;
  //   }

  //   // Check if file is a CSV
  //   if (file.type !== "text/csv") {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Invalid file type! Please upload a CSV file.",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("input_file", file);

  //   const response = await fetch(
  //     `${API_BASE_URL}/coaching-collaborator-api/api/v1/csv-question-set/`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //       },
  //       body: formData,
  //     }
  //   );

  //   if (!response.ok) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Error uploading file!",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return;
  //   }

  //   const data = await response.json();
  //   // store the original data for display
  //   setDisplayAnswerKey(data.data);
  //   // convert the data for POST request
  //   setHasData(data.data.length > 0);

  //   // Determine key names dynamically
  //   let questionKey, answerKey;
  //   const firstItem = data.data[0];
  //   const keys = Object.keys(firstItem);
  //   if (typeof firstItem[keys[0]] === "string" && !isNaN(firstItem[keys[1]])) {
  //     answerKey = keys[0];
  //     questionKey = keys[1];
  //   } else if (
  //     typeof firstItem[keys[1]] === "string" &&
  //     !isNaN(firstItem[keys[0]])
  //   ) {
  //     answerKey = keys[1];
  //     questionKey = keys[0];
  //   } else {
  //     console.log(
  //       "Unable to automatically determine question and answer keys based on the first item."
  //     );
  //     return;
  //   }

  //   const convertedData = data.data.map((item, index) => ({
  //     ques_no: index + 1, // Use the index for question number
  //     correct_ans: convertOptions(item[answerKey]), // Use the dynamically determined key for the answer
  //   }));
  //   setPostAnswerKey(convertedData);
  //   setIsError(
  //     data.data.length !== totalQuestions // set error state to true if they don't match
  //   );
  // };


  // const handleUpload = async () => {
  //   // Check if a file is selected
  //   if (!file) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Please insert a file before uploading.",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return;
  //   }

  //   // Check if the file is a CSV
  //   if (file.type !== "text/csv") {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Invalid file type! Please upload a CSV file.",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("input_file", file);

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/csv-question-set/`,
  //       {
  //         method: "POST",
  //         headers: {
  //           Accept: "application/json",
  //         },
  //         body: formData,
  //       }
  //     );

  //     if (!response.ok) {
  //       Swal.fire({
  //         title: "Error",
  //         text: "Error uploading file!",
  //         icon: "error",
  //         confirmButtonColor: "rgb(100 101 101)",
  //       });
  //       return;
  //     }

  //     const data = await response.json();
  //     // store the original data for display
  //     setDisplayAnswerKey(data.data);
  //     // convert the data for POST request
  //     setHasData(data.data.length > 0);

  //     // Determine key names dynamically
  //     let questionKey, answerKey;
  //     const firstItem = data.data[0];
  //     const keys = Object.keys(firstItem);
  //     if (
  //       typeof firstItem[keys[0]] === "string" &&
  //       !isNaN(firstItem[keys[1]])
  //     ) {
  //       answerKey = keys[0];
  //       questionKey = keys[1];
  //     } else if (
  //       typeof firstItem[keys[1]] === "string" &&
  //       !isNaN(firstItem[keys[0]])
  //     ) {
  //       answerKey = keys[1];
  //       questionKey = keys[0];
  //     } else {
  //       console.log(
  //         "Unable to automatically determine question and answer keys based on the first item."
  //       );
  //       return;
  //     }

  //     const convertedData = data.data.map((item, index) => ({
  //       ques_no: index + 1, // Use the index for question number
  //       correct_ans: convertOptions(item[answerKey]), // Use the dynamically determined key for the answer
  //     }));
  //     setPostAnswerKey(convertedData);
  //     setIsError(
  //       data.data.length !== totalQuestions // set error state to true if they don't match
  //     );
  //   } catch (error) {
  //     console.error("Error uploading file:", error);
  //     Swal.fire({
  //       title: "Error",
  //       text: "Failed to upload file",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //   }
  // };


  const flattenAnswerKey = (data) => {
    const flattenedData = [];

    data.forEach(([quesNo, answers]) => {
      answers.forEach((answer) => {
        flattenedData.push([quesNo, answer]); // Create a pair for each answer
      });
    });

    return flattenedData;
  };


  const handleUpload = async () => {
    if (!file) {
      Swal.fire({
        title: "Error",
        text: "Please insert a file before uploading.",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    if (file.type !== "text/csv") {
      Swal.fire({
        title: "Error",
        text: "Invalid file type! Please upload a CSV file.",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    const formData = new FormData();
    formData.append("input_file", file);

    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/csv-question-set/`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        }
      );

      if (!response.ok) {
        Swal.fire({
          title: "Error",
          text: "Error uploading file!",
          icon: "error",
          confirmButtonColor: "rgb(100 101 101)",
        });
        return;
      }

      const data = await response.json();
      setDisplayAnswerKey(data.data);
      setHasData(data.data.length > 0);

      let questionKey, answerKey;
      const firstItem = data.data[0];
      const keys = Object.keys(firstItem);

      // Determine question and answer keys dynamically
      if (typeof firstItem[keys[0]] === "string" && !isNaN(firstItem[keys[1]])) {
        answerKey = keys[0];
        questionKey = keys[1];
      } else if (
        typeof firstItem[keys[1]] === "string" &&
        !isNaN(firstItem[keys[0]])
      ) {
        answerKey = keys[1];
        questionKey = keys[0];
      } else {
        console.log("Unable to determine keys automatically.");
        return;
      }

      // Process data to handle multiple answers
      const convertedData = data.data.map((item) => {
        const quesNo = parseInt(item[questionKey]); // Question number
        const answers = item[answerKey]
          .split(",") // Split multiple answers by comma
          .map((opt) => convertOptions(opt.trim())); // Convert each option using the existing function

        return [quesNo, answers]; // Return the formatted question-answer pair
      });

      // Flatten the data to match the API format
      const flattenedData = flattenAnswerKey(convertedData);

      setPostAnswerKey(flattenedData);
      setIsError(data.data.length !== totalQuestions);
    } catch (error) {
      console.error("Error uploading file:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to upload file",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    }
  };
       
  // const sendTestDetails = async () => {
  //   if (!testName || !courseOpted || !selectedSubject || !selectedChapter) {
  //     Swal.fire({
  //       title: "Error in submitting the form",
  //       text: "Please fill all the input fields",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return false;
  //   }

  //   const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/new-test?client_id=${clientId}&client_br_id=${clientBranchId}&test_name=${testName}&course_id=${courseOpted}&created_by=${user_name}`;

  //   const data = {
  //     parameter_ids: [
  //       {
  //         chapter_id: selectedChapter,
  //         topic_id: topicId,
  //         subtopic_id: selectedSubtopicId,
  //       },
  //     ],
  //     ques_ans_list: postAnswerKey.map((item) => [
  //       item.ques_no,
  //       item.correct_ans,
  //     ]),
  //   };

  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(data),
  //     });

  //     const responseData = await response.json();

  //     if (response.ok && responseData.message.status === "success") {
  //       const assessmentId = responseData.message.assessment_id;
  //       setTestId(assessmentId); // Store the assessment ID for use in the next API call

  //       Swal.fire({
  //         title: "Answer Key Submitted Successfully",
  //         icon: "success",
  //         timer: 2000,
  //         confirmButtonColor: "#318682",
  //       });

  //       return assessmentId; // Return the assessment ID to be used in handleCreate
  //     } else {
  //       Swal.fire({
  //         title: "Error in submitting the form",
  //         text: "Failed to create the test",
  //         icon: "error",
  //         confirmButtonColor: "rgb(100 101 101)",
  //       });
  //       return false;
  //     }
  //   } catch (error) {
  //     console.error("Error submitting test details:", error);
  //     Swal.fire({
  //       title: "Error",
  //       text: "Failed to submit test details",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return false;
  //   }
  // };
  // const sendTestDetails = async () => {
  //   // Check if testName, courseOpted, selectedSubject, and selectedChapter are provided
  //   if (!testName || !courseOpted || !selectedSubject || !selectedChapter) {
  //     Swal.fire({
  //       title: "Error in submitting the form",
  //       text: "Please fill all the input fields",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return false;
  //   }

  //   // Check if a file is selected and if it's not empty
  //   if (!file || file.size === 0) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "You have not selected any file or your file is empty.",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return false; // Stop execution if no file or if the file is empty
  //   }

  //   const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/new-test?client_id=${clientId}&client_br_id=${clientBranchId}&test_name=${testName}&course_id=${courseOpted}&created_by=${user_name}`;

  //   const data = {
  //     parameter_ids: [
  //       {
  //         chapter_id: selectedChapter,
  //         topic_id: topicId,
  //         subtopic_id: selectedSubtopicId,
  //       },
  //     ],
  //     ques_ans_list: postAnswerKey.map((item) => [
  //       item.ques_no,
  //       item.correct_ans,
  //     ]),
  //   };

  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(data),
  //     });

  //     const responseData = await response.json();

  //     if (response.ok && responseData.message.status === "success") {
  //       const assessmentId = responseData.message.assessment_id;
  //       setTestId(assessmentId); // Store the assessment ID for use in the next API call

  //       Swal.fire({
  //         title: "Answer Key Submitted Successfully",
  //         icon: "success",
  //         timer: 2000,
  //         confirmButtonColor: "#318682",
  //       });

  //       return assessmentId; // Return the assessment ID to be used in handleCreate
  //     } else {
  //       Swal.fire({
  //         title: "Error in submitting the form",
  //         text: "Failed to create the test",
  //         icon: "error",
  //         confirmButtonColor: "rgb(100 101 101)",
  //       });
  //       return false;
  //     }
  //   } catch (error) {
  //     console.error("Error submitting test details:", error);
  //     Swal.fire({
  //       title: "Error",
  //       text: "Failed to submit test details",
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //     return false;
  //   }
  // };

  const sendTestDetails = async () => {
    if (!testName || !courseOpted || !selectedSubject || !selectedChapter) {
      Swal.fire({
        title: "Error in submitting the form",
        text: "Please fill all the input fields",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return false;
    }

    if (!file || file.size === 0) {
      Swal.fire({
        title: "Error",
        text: "You have not selected any file or your file is empty.",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return false;
    }

    const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/new-test?client_id=${clientId}&client_br_id=${clientBranchId}&test_name=${testName}&course_id=${courseOpted}&created_by=${user_name}`;

    const data = {
      parameter_ids: [
        {
          chapter_id: selectedChapter,
          topic_id: topicId,
          subtopic_id: selectedSubtopicId,
        },
      ],
      ques_ans_list: postAnswerKey, // Use the processed answer key data
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();

      if (response.ok && responseData.message.status === "success") {
        const assessmentId = responseData.message.assessment_id;
        setTestId(assessmentId);

        Swal.fire({
          title: "Answer Key Submitted Successfully",
          icon: "success",
          timer: 2000,
          confirmButtonColor: "#318682",
        });

        return assessmentId;
      } else {
        Swal.fire({
          title: "Error in submitting the form",
          text: "Failed to create the test",
          icon: "error",
          confirmButtonColor: "rgb(100 101 101)",
        });
        return false;
      }
    } catch (error) {
      console.error("Error submitting test details:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to submit test details",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return false;
    }
  };


  useEffect(() => {
    const fetchBatch = async () => {
      if (courseOpted) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-name-by-course-id/?course_id=${courseOpted}`
        );
        const data = await response.json();
        setBatchNameByCourseID(data);
      }
    };
    fetchBatch();
  }, [courseOpted]);

  const handleCreate = async () => {
    const assessmentId = testId || (await sendTestDetails());

    if (!assessmentId) {
      return; // Do not proceed if test creation failed
    }

    if (!batchId || !due_dateId) {
      Swal.fire({
        title: "DPP Answer Key Uploaded Sucessfully",
        icon: "success",
        confirmButtonColor: "rgb(100 101 101)",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
      return;
    }

    const apiUrl = `${API_BASE_URL}/coaching-collaborator-api/api/v1/assign-dpp-to-batch?assessment_id=${assessmentId}&batch_id=${batchId}&due_date=${due_dateId}&user_name=${user_name}`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        Swal.fire({
          title: "Success",
          text: "Test Created & Assigned Successfully",
          icon: "success",
          confirmButtonColor: "#318682",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
        resetForm();
      } else {
        throw new Error("Failed to assign the test");
      }
    } catch (error) {
      console.error("There was a problem with your fetch operation:", error);
      Swal.fire("Error", "Failed to assign the test", "error");
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  const resetForm = () => {
    setTestId("");
    setBatchId("");
    setDue_dateId("");
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
      );
      const data = await response.json();
      setCourses(data);
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      if (courseOpted) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${courseOpted}`
        );
        const data = await response.json();
        setSubjects(data);
        setSelectedSubjectLabel(""); // Reset the subject label
        setSelectedChapterLabel(""); // Reset the chapter label
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchSubjects();
  }, [courseOpted]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (selectedSubject) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapters-by-subject/?subject_id=${selectedSubject}`
        );
        const data = await response.json();
        setChapters(data);
        setSelectedChapterLabel(""); // Reset the chapter label
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchChapters();
  }, [selectedSubject]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (selectedChapter) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-topics-by-chapter/?chapter_id=${selectedChapter}`
        );
        const data = await response.json();
        setTopics(data);
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchTopics();
  }, [selectedChapter]);

  useEffect(() => {
    const fetchSubtopics = async () => {
      if (topicId) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subtopics-by-topic/?topic_id=${topicId}`
        );
        const data = await response.json();
        setSubtopics(data);
      }
    };

    fetchSubtopics();
  }, [topicId]);

  useEffect(() => {
    setDropdownKey((prevKey) => prevKey + 1);
  }, [courseOpted, selectedSubject, selectedChapter, topicId]);

  const chunkedAnswerKey = displayAnswerKey.reduce(
    (resultArray, item, index) => {
      const chunkIndex = Math.floor(index / 10);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // start a new chunk
      }

      resultArray[chunkIndex].push(item);

      return resultArray;
    },
    []
  );

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div className="container-UP " style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <p className="title-cb">Upload DPP Answer Key</p>
          <div className="mb-2-UP">
            <button className="cr-cancel-btn me-cs4" onClick={handleCancel}>
              CANCEL
            </button>
            <button className="cr-create-btn" onClick={handleCreate}>
              SUBMIT
            </button>
          </div>
        </div>
        <hr
          style={{
            color: "black",
            backgroundColor: "black",
            marginTop: "5px",
          }}
        />
      </div>

      <div className="container-cs-fluid-3 ms-cs3 mt-cs3 mb-cs3">
        <div className="card-cs1 card-border-CR">
          <div className="basic-info-color transparent-margin-left-UP transparent-margin-all">
            TEST DETAILS
          </div>
          <div className="row-UP">
            <div className="col-UP">
              <div className="div mt-cs2 grey-color-font">Test Name </div>
              <div className="input-groupmb-cs3 mt-cs2">
                <input
                  type="text"
                  className="input-UP"
                  style={{ outline: "none" }}
                  aria-div="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  onChange={(e) => setTestName(e.target.value)} // update the test name when the user types in the input field
                />
              </div>
              <div className="input-groupmb-cs3 mt-cs2">
                <DropDown
                  label="Course"
                  style={{ width: "27.1%" }}
                  setSelected={setCourseOpted}
                  options={courses.map((course) => ({
                    label: course.course_name,
                    id: course.course_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div className="input-groupmb-cs3 mt-cs2">
                <DropDownUP
                  label="Subject"
                  style={{ width: "27.1%" }}
                  setSelected={setSelectedSubject}
                  selectedLabel={selectedSubjectLabel} // Pass the selected label
                  setSelectedLabel={setSelectedSubjectLabel} // Pass the function to update the selected label
                  options={subjects.map((subject) => ({
                    label: subject.subject_name,
                    id: subject.subject_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div className="input-groupmb-cs3 mt-cs2">
                <DropDownUP
                  label="Chapter"
                  style={{ width: "27.1%" }}
                  setSelected={setSelectedChapter}
                  selectedLabel={selectedChapterLabel} // Pass the selected label
                  setSelectedLabel={setSelectedChapterLabel} // Pass the function to update the selected label
                  options={chapters.map((chapter) => ({
                    label: chapter.chapter_name,
                    id: chapter.chapter_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div className="input-groupmb-cs3 mt-cs2">
                <DropDownUP2
                  label="Topic"
                  style={{ width: "27.1%" }}
                  setSelected={setTopicId}
                  selectedLabel={selectedTopicLabel} // Pass the selected label
                  setSelectedLabel={setSelectedTopicLabel} // Pass the function to update the selected label
                  options={topics.map((topic) => ({
                    label: topic.topic_name,
                    id: topic.topic_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <DropDownUP2
                label="Sub-topic"
                style={{ width: "27.1%" }}
                setSelected={setSelectedSubtopicId} // Set the selected subtopic id here
                selectedLabel={selectedSubtopicLabel} // Pass the selected subtopic label here
                setSelectedLabel={setSelectedSubtopicLabel} // Pass the function to update the selected subtopic label
                options={subtopics.map((subtopic) => ({
                  label: subtopic.subtopic_name,
                  id: subtopic.subtopic_id,
                }))}
                isRequired={true}
              />
              <div className="div mt-cs2 grey-color-font">Total Questions </div>
              <div className="input-groupmb-cs3 mt-cs2">
                <input
                  type="text"
                  style={{ outline: "none" }}
                  className={`input-UP-2-2 ${isError ? "error" : ""}`} // add 'error' class if there's an error
                  aria-div="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  onChange={(e) => setTotalQuestions(e.target.value)} // update the total number of questions when the user inputs a value
                />
              </div>
              <div className="div mt-cs2 grey-color-font">
                Upload Answer Key{" "}
              </div>
              <div className="input-groupmb-cs3 mt-cs2">
                <button
                  className="me-3-UP browse-button"
                  onClick={() => fileInput.current.click()}
                >
                  Browse
                </button>
                <input
                  type="file"
                  ref={fileInput}
                  style={{ display: "none" }} // hide the default file input
                  onChange={handleFileChange}
                />
                <input
                  type="text"
                  className="input-UP-9"
                  style={{ outline: "none" }}
                  value={file ? file.name : ""} // display the selected file name
                  readOnly // prevent manual editing
                />
              </div>
              <button className="upload-UP-button" onClick={handleUpload}>
                Upload
              </button>{" "}
              <div className="ms-2-UP mt-3-UP grey-color-font">
                Answer key preview
              </div>
            </div>
          </div>{" "}
          <div style={{ padding: "1px" }}>
            <div
              className={`UP-bg-color ${hasData ? "UP-bg-color-with-data" : ""
                }`}
            >
              {chunkedAnswerKey.slice(0, 40).map((chunk, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginLeft  : "40px",
                  }}
                >
                  {chunk.slice(0, 10).map((item, index) => {
                    let questionKey, answerKey;
                    const keys = Object.keys(item);
                    if (
                      typeof item[keys[0]] === "string" &&
                      !isNaN(item[keys[1]])
                    ) {
                      answerKey = keys[0];
                      questionKey = keys[1];
                    } else if (
                      typeof item[keys[1]] === "string" &&
                      !isNaN(item[keys[0]])
                    ) {
                      answerKey = keys[1];
                      questionKey = keys[0];
                    } else {
                      console.log(
                        "Unable to automatically determine question and answer keys based on the first item."
                      );
                      return null;
                    }

                    return (
                      <div
                        key={index}
                        style={{
                          width: "10%",
                          padding: "10px",
                          display: "flex",
                          // justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span className="span-UP-1">{item[questionKey]}.</span>{" "}
                        <span className="span-UP-2"> {item[answerKey]}</span>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div style={{ paddingLeft: "15px", paddingRight: "14px" }}>
        <div className="personal-info">
          <div className="personal-header">
            <div className="header">
              <h2>Assign DPP</h2>
            </div>
          </div>
          <div className="accordion-content">
            <div className="assign-test-container">
              <div className="academic-tile">#</div>
              <div className="academic-tile">DPP Name</div>
              <div className="academic-tile">Batch</div>
              <div className="academic-tile">Due Date</div>
              <div className="class-name"></div>
              <div className="">
                <div>
                  <input
                    className="testname-UQ"
                    type="text"
                    value={testName} // Use the passed prop to display the DPP name
                    disabled
                  />
                </div>
              </div>
              <div className="">
                <DropDown
                  key={dropdownKey}
                  setSelected={setBatchId}
                  style={{ width: "240px" }}
                  options={
                    batchnameByCourseID && Array.isArray(batchnameByCourseID[0])
                      ? batchnameByCourseID[0].map((batch) => ({
                        label: batch.batch_name,
                        id: batch.batch_id,
                      }))
                      : []
                  }
                  Height="auto"
                  minheight="150px"
                  OverFlow="auto"
                />
              </div>
              <div className="">
                <FormInput
                  type="datetime-local"
                  onChange={(e) => setDue_dateId(e.target.value)}
                  value={due_dateId}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadQuestions;
